<template>
  <div class="ed--list">
    <div class="ed--list-inner">
      <div class="ed--card-wrapper">
        <div v-for="(item, key) in eds" :key="key" class="ed--card">
          <div class="ed--img">
            <img :src="`${imgurl}${item.year}.png`" />
          </div>
          <div class="ed--info">
            <span class="ed--term f-ui-3">
              {{ item.year }}-{{ item.max ? item.max : "Present" }}
            </span>
            <span class="f-ui-3">Executive Director </span>
            <span class="f-ui-1">
              <strong>{{ item.name }}</strong>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    eds: {
      required: true,
    },
  },
  data() {
    return {
      imgurl:
        "https://ieamaps.blob.core.windows.net/test/50-anniversary/img/eds/",
    };
  },
};
</script>

<style>
.ed--list {
  width: 100%;
  height: auto;
  margin-top: 32px;
}
.ed--list-inner {
  height: 75px;
  width: auto;
  overflow: hidden;
}
.ed--card-wrapper {
  transform: translateY(-525px);
}
.ed--card {
  height: 75px;
  box-sizing: border-box;
  padding: 5px 8px;
  display: flex;
  align-items: center;
}
.ed--img {
  width: 65px;
  height: 65px;
  overflow: hidden;
  display: flex;
}
.ed--img img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}
.ed--info {
  display: flex;
  flex-flow: column;
  justify-content: center;
  width: auto;
  height: auto;
  margin-left: 24px;
}
.ed--term {
  margin-bottom: 6px;
  color: #04f;
}

@media screen and (max-width: 959px) {
  .ed--list-inner,
  .ed--card {
    height: 58px;
  }
  .ed--img {
    width: 45px;
    height: 45px;
  }
  .ed--info {
    margin-left: 14px;
  }
}

@media screen and (max-width: 729px) {
  .ed--list {
    margin-top: 16px;
  }
  .ed--img {
    display: none;
  }
  .ed--info {
    margin-left: 0;
  }
}

@media screen and (min-width: 960px) and (max-height: 700px) {
  .ed--list-inner,
  .ed--card {
    height: 55px;
  }
  .ed--img {
    width: 45px;
    height: 45px;
  }
}
@media screen and (max-width: 499px) {
  .ed--list {
    display: none;
  }
}
</style>
